<template>
    <div class="card__wrapper">
        <h2 class="text-center">{{ product_name }}</h2>
        <div class="card" v-for="(question) in filteredQuestions" v-bind:key="question.id" style="border: none;text-align: center;">

            <span class="d-none">Has subquestions: {{ question.sub_questions.length }}</span>

            <div class="card-body">
                <p class="card-text">{{ question.question }}</p>
            </div>
            <div>
                <div v-if="question.question_type === 'numeric'">
                    <input type="number" class="form-control" v-model="amount">
                    <a href="#" class="btn btn-outline-primary" v-on:click.self.prevent="addToOffer(question.id, question.question_type)">Verder</a>
                    <a href="#" class="btn btn-outline-primary" v-on:click.self.prevent="nextQuestion()">Niet van toepassing</a>
                </div>
                <div v-if="question.question_type === 'boolean'">
                    <a href="#" class="btn btn-outline-primary" v-on:click.self.prevent="addToOffer(question.id, question.question_type)">Ja</a>
                    <a href="#" class="btn btn-outline-primary" v-on:click.self.prevent="nextQuestion()">Nee</a>
                </div>
            </div>
        </div>
        <div v-if="questions.length == cardCount">
            <div class="text-center wrapper">
                <button class="btn btn-primary" id="btn-add-product" @click="saveProduct('start')">Voeg een product toe</button>
                <button class="btn btn-outline-primary" @click="saveProduct('checkout')">Afronden</button>
            </div>
        </div>
    </div>
</template>

<script>
    import ajax from '../ajax';
    import _ from 'lodash';

    export default {

        name: "Questions",

        data() {
            return {
                cardCount   : 0,
                questions   : [],
                answers     : [],
                amount      : 0,
                product_name: this.$route.params.product_name
            }
        },
        methods:
        {
            resetData() {
                this.$data.amount  = 0;
            },

            addToOffer(qid, type) {
                let value;

                if (type === 'numeric') {
                    value = this.$data.amount;
                } else if (type === 'boolean') {
                    value = true;
                } else {
                    return;
                }

                // Create a new  'wrapper' OBJECT which hold: product_id, question_id, type and the answer.
                let eventData   = { qid: qid, type: type, answer: value };
                let answerIndex = _.findIndex(this.$data.answers, answer => answer.qid === eventData.qid);

                if (answerIndex > -1) {
                    let answer = this.$data.answers[answerIndex];

                    answer.type     = eventData.type;
                    answer.answer   = eventData.answer;

                    this.$data.answers.splice(answerIndex, 1);
                    this.$data.answers.push(answer);
                } else {
                    this.$data.answers.push({
                        qid     : eventData.qid,
                        type    : eventData.type,
                        answer  : eventData.answer
                    });
                }

                this.resetData();
                this.$data.cardCount++;
            },

            // Show the next card to the user.
            nextQuestion() {
                this.$data.cardCount++;
            },

            // LocalStorage approach
            saveProduct(type) {
                this.$root.$emit('save-product', {
                    product: this.$route.params.pid,
                    answers: this.$data.answers
                });
                if (type === 'checkout') {
                    this.$router.push({ name: 'checkout'})
                } else {
                    this.$router.push({ name: 'categories'})
                }
            },
        },

        mounted: function () {
            ajax
            .get(`/api/v1/product/${this.$route.params.pid}/questions`)
            .then(response =>{
                if(response.status === 200) {
                    console.log(response.data);
                    this.questions = response.data
                }
            })
            .catch(error =>{
                console.log(error);
            })
        },
        computed: {
            filteredQuestions () {
                return this.questions.filter((question, index) => index == this.cardCount);
            }
        }
    }
</script>

<style scoped lang="scss">
.card__wrapper {
    .card {
        background-color: transparent;
    }

    .wrapper {
        margin-top: 50px;
    }

    #btn-add-product {
        font-weight: bold;
        text-transform: uppercase;
        padding: 9px 22px;
        border: 1px solid black;
        display: block;
        margin: 0 auto 20px auto;
        @media (min-width: 600px){
            padding: 19px 44px;
            display: inline-block;
            margin-bottom: 0;
            margin-right: 20px;
        }
    }
    .btn-outline-primary {
        background: transparent !important;
        text-transform: uppercase !important;
        border-radius: 0 !important;
        border-color: white !important;
        color: white !important;
        background: none !important;
        padding: 8px 35px;
        &:hover {color: black !important;
            background-color: white !important;
        }
    }

    input[type="number"] {
        background: white !important;
        border: none !important;
        border-radius: 0 !important;
        width: 150px;
        margin: 20px auto 50px auto;
    }

    .card-text {
        background: transparent;
        padding: 11px;
        border-radius: 12px;
        color: white;
        font-size: 1.3em;
        font-weight: 300;
        margin-bottom: 10px;
    }
}
</style>
